import { audioApi } from '@/api/audio.api';
import { transcriptionFrenchApi } from '@/api/transcriptionFrench.api';
import type { OutboxSender } from './outbox-flush';
import type { OutboxItem } from './outbox.types';

/**
 * The real send of each kind of queued contribution, through the usual API
 * services, flagged as background so a 401 pauses the queue instead of
 * signing the person out.
 */
export const sendOutboxItem: OutboxSender = (item, headers) => {
  const options = { headers, background: true };
  switch (item.kind) {
    case 'speak-audio': {
      const { payload } = item as OutboxItem<'speak-audio'>;
      const file = new File([payload.audio], payload.fileName, { type: payload.audio.type });
      return audioApi.uploadWordAudio(file, payload.data, options);
    }
    case 'transcription-batch': {
      const { payload } = item as OutboxItem<'transcription-batch'>;
      return transcriptionFrenchApi.submitBatchTranscriptions(payload, options);
    }
    default:
      return Promise.reject(new Error(`UNKNOWN_OUTBOX_KIND`));
  }
};
